import type { LocationScopedUser } from 'app/types/location-access'

export const USER_LOCATION_ACCESS_FIELDS = `type allowedLocationIds assignedLocationIds workspaces { id locationIds }`

/**
 * Same resolution as UserLocationSelector: this workspace's entry wins, the legacy top-level
 * lists are the fallback, and an empty list at the level that answers means every location.
 */
export function userHasLocationAccess(user: LocationScopedUser, locationId: string, workspaceId?: string): boolean {
  if (user.type === `super`) return true
  const workspaceEntry = user.workspaces?.find((workspace) => workspace.id === workspaceId)
  const locationIds =
    workspaceEntry?.locationIds ??
    (user.allowedLocationIds?.length ? user.allowedLocationIds : user.assignedLocationIds)
  return !locationIds?.length || locationIds.includes(locationId)
}
